<template>
  <div>
    <CCard class="bg-style2">
      <CCardHeader class="bg-gradient-danger text-white" style="border-radius: 1rem 1rem 0 0;">
        <span class="font-weight-bold h6">
          <CIcon class="mr-2" v-if="icon" :name="icon" />
          {{ caption }}
        </span>
      </CCardHeader>

      <CCardBody>
        <CRow class="mb-2 justify-content-center">
          <!-- STATUS -->
          <CCol col="6">
            <label class="fw-semibold text-dark">STATUS</label>
            <Multiselect
                v-model="status"
                :options="statuses"
                label="label"
                track-by="value"
                placeholder="Select status"
            />
          </CCol>

          <!-- CANDIDATE TYPE -->
          <CCol col="6">
            <label class="fw-semibold text-dark">CANDIDATE TYPE</label>
            <Multiselect
                v-model="userType"
                :options="types"
                label="label"
                track-by="value"
                placeholder="Select type"
            />
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import { mapGetters } from 'vuex'

export default {
  name: 'SelectDropdown',
  components: { Multiselect },
  props: {
    icon: {
      type: String,
      default: 'cil-magnifying-glass'
    },
    caption: {
      type: String,
      default: 'SEARCH'
    }
  },
  data() {
    return {
      status: null,
      userType: null
    }
  },
  computed: {
    ...mapGetters({
      statuses: 'dropdown/formattedStatuses',
      types: 'dropdown/formattedTypes'
    })
  },
  watch: {
    status(val) {
      this.$emit('filter-changed', {
        status: this.status,
        userType: this.userType
      });
    },
    userType(val) {
      this.$emit('filter-changed', {
        status: this.status,
        userType: this.userType
      });
    }
  },
  async mounted() {
    await this.$store.dispatch('dropdown/fetchAllDropdowns')
  }
}
</script>

<style scoped>
.multiselect__control {
  min-height: 38px;
}
</style>
